import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { themeColors } from 'src/modules/lms/config';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import useStyles from 'src/modules/lms/shared/cardMedia/styles';
import StarIcon from '@mui/icons-material/Star';
import { isNull } from 'lodash';

function SessionStatus({ session, hover,fav }) {
  const classes = useStyles();
  const rolePlays = session?.rolePlays?.length;
  const score = [];
  const allRolePlayAverageScore = () => {
    let lastThreeRolePlays = session?.rolePlays.slice(-3);
    lastThreeRolePlays?.map((item) => {
      score.push(item.score);
    });
    const sum = score.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const averageScore = (sum / rolePlays)?.toFixed(1);
    return averageScore;
  };

  const competitionRolePlays = session?.competition?.roleplaysDone;
  const completedRolePlaysInCompetition = session?.competition?.roleplays;
  const competitionAverageScore = session?.competition?.averageScore?.toFixed(1);

  return (
    <>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Stack direction="row" gap={0.3} mt={0.3}>
          {rolePlays ? (
            <>
              <GraphicEqIcon
                className={classes.statusIcon}
                style={{ color: hover ? 'white' : themeColors.fadedText }}
              />
              <Typography variant={'h6'} style={{ color: hover ? 'white' : themeColors.fadedText }}>
                {rolePlays}
              </Typography>
              <Typography variant={'h6'} style={{ color: hover ? 'white' : themeColors.fadedText }}>
                |
              </Typography>
              <Typography variant={'h6'} style={{ color: hover ? 'white' : themeColors.fadedText }}>
                {allRolePlayAverageScore()}
              </Typography>
              <Typography
                mr={1}
                variant={'h6'}
                style={{ color: hover ? themeColors.yellow : themeColors.fadedText }}
              >
                /5
              </Typography>
            </>
          ) : null}
          {session?.competition ? (
            <>
              <EmojiEventsOutlinedIcon
                className={classes.statusIcon}
                style={{ color: hover ? 'white' : themeColors.fadedText }}
              />
              <Typography
                variant={'h6'}
                style={{ color: hover ? themeColors.greenText : themeColors.fadedText }}
              >
                {competitionRolePlays + '/'}
              </Typography>
              <Typography variant={'h6'} style={{ color: hover ? 'white' : themeColors.fadedText }}>
                {completedRolePlaysInCompetition}
              </Typography>
              <Typography variant={'h6'} style={{ color: hover ? 'white' : themeColors.fadedText }}>
                |
              </Typography>
              <Typography variant={'h6'} style={{ color: hover ? 'white' : themeColors.fadedText }}>
                {competitionAverageScore}
              </Typography>
              <Typography
                variant={'h6'}
                style={{ color: hover ? themeColors.yellow : themeColors.fadedText }}
              >
                /5
              </Typography>
            </>
          ) : null}
        </Stack>
        {fav ? (
          <Box mt={0.3}>
            <StarIcon fontSize="2px" sx={{ fill: 'rgba(255, 212, 126, 1)' }} />
          </Box>
        ) : null}
      </Box>
    </>
  );
}

export default SessionStatus;
